/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import DayPicker from 'app/components/common/DayPicker.jsx';
import TimePickerHour from 'app/components/common/TimePickerHour.jsx';
import TimePickerMinute from 'app/components/common/TimePickerMinute.jsx';
import TimePickerMeridiem from 'app/components/common/TimePickerMeridiem.jsx';
import DropdownList from 'react-widgets/DropdownList';
import CategoryItem from 'app/components/DropDownItems/CategoryItem.jsx';
import * as _ from 'underscore';

class QueueScheduleRowEditorMobile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            days: null,
            time: null,
            category: null,
            categoryList: this.props.categoryList.slice(1)
        };

        this.onTimeChange = this.onTimeChange.bind(this);
        this.onCategoryChange = this.onCategoryChange.bind(this);
        this.onSaveSchedule = this.onSaveSchedule.bind(this);
        this.onDayToggle = this.onDayToggle.bind(this);

    }

    componentDidMount() {
        let time = new moment(),
            splitTime = _.clone(this.props.schedule.s_startTime).split(":"),
            category = null;

        if (this.props.schedule.s_tagID !== "0") {
            category = _.find(this.props.categoryList, {id: this.props.schedule.s_tagID});
        };

        if (this.props.user.detail && this.props.user.detail.timezone) {
            time = moment().tz(this.props.user.detail.timezone);
        }

        time.hour(splitTime[0]);
        time.minute(splitTime[1]);

        this.setState({
            time,
            days: parseInt(this.props.schedule.s_days, 10),
            category
        });

    }

    onDayToggle(e) {
        let day = parseInt(e.currentTarget.dataset.day, 10),
            days = parseInt(this.state.days, 10);

        if (days & day) {
            days = days ^ day;
        } else {
            days = days | day;
        }

        this.setState({
            days
        });

    }

    onTimeChange(value, e) {

        let time = moment(this.state.time);

        switch (e.currentTarget.dataset.field) {
            case "hours":
                time.tz(this.props.user.detail.timezone);
                time.hour(value);
                break;

            case "minutes":
                time.minute(value);
                break;

            case "meridiem":
                if (time.hour() > 12 && value === 'AM') {
                    time.subtract(12, 'hours');
                } else if (time.hour() < 12 && value === 'PM') {
                    time.add(12, 'hours');
                } else {
                    if (value === 'AM') {
                        time.hour(0);
                    } else {
                        time.hour(12);
                    }
                }
                break;

            default:
                break;
        }

        this.setState({
            time
        });

    }

    onCategoryChange(category) {

        this.setState({
            category: category.id
        });

    }

    onSaveSchedule() {

        this.props.changeHandler(
            this.props.schedule.s_id,
            this.state.time.format('HH:mm:00'),
            this.state.category,
            this.state.days
        );

    }

    render() {
        let categoryOnClick = null,
            disabled = false,
            error = null;

        if (this.props.user.perms.resources && !this.props.user.perms.resources.categories) {
            disabled = true;
            categoryOnClick = this.props.onCategoryUpgrade;
        }

        if (this.props.error) {
            error = (
                <div className="schedule-error">{this.props.error}</div>
            );
        }

        return (
            <div className="queue-schedule-controls mobile">
                {error}
                <DayPicker
                    {...this.props}
                    days={this.state.days}
                    setDays={this.onDayToggle}
                    scheduleId={this.props.schedule.s_id}
                    labelPostion="bottom"/>
                <div className="time-pickers">
                    <TimePickerHour
                        {...this.props}
                        changeHandler={this.onTimeChange}
                        scheduleTime={this.state.time}
                        id={this.props.schedule.s_id}/>
                    <TimePickerMinute
                        {...this.props}
                        changeHandler={this.onTimeChange}
                        scheduleTime={this.state.time}
                        id={this.props.schedule.s_id}/>
                    <TimePickerMeridiem
                        {...this.props}
                        changeHandler={this.onTimeChange}
                        scheduleTime={this.state.time}
                        id={this.props.schedule.s_id}/>
                </div>
                <div className="category-dropdown" onClick={categoryOnClick}>
                    <DropdownList
                        data={this.state.categoryList}
                        dataKey='id'
                        filter={false}
                        renderListItem={({ item }) => {
                            return (
                                <CategoryItem
                                    item={item}/>
                            );
                        }}
                        renderValue={({ item }) => {
                            return (
                                <CategoryItem
                                    item={item}/>
                            );
                        }}
                        placeholder="Choose Category"
                        className="category-drop"
                        disabled={disabled}
                        value={this.state.category}
                        onChange={this.onCategoryChange} />
                </div>
                <div className="mobile-queue-row-buttons">
                    <button className="btn-secondary active delete-schedule active" data-delete={true} data-sid={this.props.schedule.s_id} onClick={this.props.clickHandler}>
                        {"delete"}
                    </button>
                    <button className="btn-secondary active save-schedule active" onClick={this.onSaveSchedule}>
                        save
                    </button>
                </div>

            </div>
        );
    }
}

QueueScheduleRowEditorMobile.displayName = "QueueScheduleRowEditorMobile";

QueueScheduleRowEditorMobile.propTypes = {

};

QueueScheduleRowEditorMobile.defaultProps = {

};

export default QueueScheduleRowEditorMobile;
